import { render, staticRenderFns } from "./Tenancy.vue?vue&type=template&id=633d7a44&scoped=true"
import script from "./Tenancy.vue?vue&type=script&lang=js"
export * from "./Tenancy.vue?vue&type=script&lang=js"
import style0 from "./Tenancy.vue?vue&type=style&index=0&id=633d7a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d7a44",
  null
  
)

export default component.exports